<style lang="scss" scoped>
.max-w-800 {
    max-width: 800px;
}
</style>

<template>
    <div class="popup px-16 py-24 p-md-24 p-lg-40" ref="fixBottom">
        <h2 class="mb-32">Stel zelf je dag samen</h2>
        <p class="mb-40">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
            condimentum hendrerit urna et facilisis.
        </p>
        <div class="d-flex justify-content-between m-n4">
            <div class="flex-1 p-4">
                <a
                    class="btn btn-accent d-flex align-items-center whitespace-nowrap text-white w-100"
                    style="color: white !important"
                    :href="
                        route('nl.activities', {
                            categories: 'formats'
                        })
                    "
                    ><span v-html="svg('view-add-grid', 'mr-8')" /> Start met
                    een voorbeeld</a
                >
            </div>
            <div class="flex-1 p-4">
                <button
                    class="btn btn-accent-light d-flex align-items-center whitespace-nowrap text-accent w-100"
                    style="color: var(--accent) !important"
                    @click="$emit('close')"
                >
                    <span v-html="svg('pencil-alt', 'mr-8')" />
                    Start met een lege dag
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import safariFixedBottom from "../../mixins/safari-fixed-bottom";

export default {
    mixins: [safariFixedBottom],

    data: () => ({}),

    mounted() {},

    methods: {}
};
</script>
